// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Theme from "../../styles/Theme.bs.js";
import * as React from "react";
import * as Emotion from "../../bindings/Emotion.bs.js";
import * as AuthContext from "../../context/AuthContext.bs.js";
import * as ThemePreference from "../../styles/ThemePreference.bs.js";
import * as JsxRuntime from "react/jsx-runtime";
import * as RescriptReactRouter from "@rescript/react/src/RescriptReactRouter.bs.js";

function NavBar$NavBar(props) {
  let auth = AuthContext.useAuth();
  let url = RescriptReactRouter.useUrl(undefined, undefined);
  let match = url.path;
  let currentPath = match !== 0 ? "/" + match.hd : "/";
  let navStyles = Emotion.Css.css({
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "1.5rem 2rem",
    backgroundColor: Emotion.Utils.Color.bgPrimary,
    position: "sticky",
    top: "0",
    zIndex: "100"
  });
  let brandStyles = Emotion.Css.css({
    fontFamily: Theme.Theme.Typography.fontFamily.serif,
    fontSize: "1.5rem",
    fontWeight: "400",
    letterSpacing: "-0.02em",
    color: Emotion.Utils.Color.textPrimary,
    cursor: "pointer",
    textDecoration: "none"
  });
  let linksStyles = Emotion.Css.css({
    display: "flex",
    gap: "2rem",
    alignItems: "center"
  });
  let linkStyles = active => Emotion.Css.css({
    color: active ? Emotion.Utils.Color.textPrimary : Emotion.Utils.Color.textSecondary,
    textDecoration: "none",
    fontWeight: active ? "600" : "400",
    fontSize: "0.75rem",
    letterSpacing: "0.08em",
    textTransform: "uppercase",
    cursor: "pointer",
    transition: "color 200ms ease-out"
  });
  let match$1 = React.useState(() => ThemePreference.initial());
  let setTheme = match$1[1];
  let theme = match$1[0];
  let toggleStyles = Emotion.Css.css({
    background: "transparent",
    border: `1px solid ` + Emotion.Utils.Color.border,
    color: Emotion.Utils.Color.textSecondary,
    borderRadius: Emotion.Utils.Border.getRadius("md"),
    padding: "0.35rem 0.65rem",
    fontFamily: "inherit",
    fontSize: "0.75rem",
    letterSpacing: "0.06em",
    textTransform: "uppercase",
    cursor: "pointer",
    transition: "color 200ms ease-out, border-color 200ms ease-out",
    ":hover": {
      color: Emotion.Utils.Color.textPrimary,
      borderColor: Emotion.Utils.Color.borderHover
    }
  });
  let handleNav = (path, evt) => {
    evt.preventDefault();
    RescriptReactRouter.push(path);
  };
  let handleThemeToggle = _evt => {
    let next = ThemePreference.toggle(theme);
    ThemePreference.apply(next);
    setTheme(param => next);
  };
  let match$2 = auth.state;
  let tmp;
  tmp = typeof match$2 !== "object" ? null : JsxRuntime.jsx("a", {
      children: "Journal",
      className: linkStyles(currentPath === "/journal"),
      href: "/journal",
      onClick: evt => handleNav("/journal", evt)
    });
  let user = auth.state;
  let tmp$1;
  tmp$1 = typeof user !== "object" ? JsxRuntime.jsx("a", {
      children: "Sign In",
      className: linkStyles(currentPath === "/login"),
      href: "/login",
      onClick: evt => handleNav("/login", evt)
    }) : JsxRuntime.jsx("a", {
      children: user._0.name,
      className: linkStyles(currentPath === "/login"),
      href: "/login",
      onClick: evt => handleNav("/login", evt)
    });
  return JsxRuntime.jsxs("nav", {
    children: [
      JsxRuntime.jsx("a", {
        children: "The Journal",
        className: brandStyles,
        href: "/",
        onClick: evt => handleNav("/", evt)
      }),
      JsxRuntime.jsxs("div", {
        children: [
          JsxRuntime.jsx("button", {
            children: theme === "light" ? "Dark" : "Light",
            "aria-label": theme === "light" ? "Switch to dark theme" : "Switch to light theme",
            className: toggleStyles,
            type: "button",
            onClick: handleThemeToggle
          }),
          JsxRuntime.jsx("a", {
            children: "Posts",
            className: linkStyles(currentPath === "/posts"),
            href: "/posts",
            onClick: evt => handleNav("/posts", evt)
          }),
          JsxRuntime.jsx("a", {
            children: "About",
            className: linkStyles(currentPath === "/about"),
            href: "/about",
            onClick: evt => handleNav("/about", evt)
          }),
          tmp,
          tmp$1
        ],
        className: linksStyles
      })
    ],
    className: navStyles
  });
}

let NavBar = {
  make: NavBar$NavBar
};

export {
  NavBar,
}
/* Theme Not a pure module */
